export const getOmnibusErrorsAsyncData = state => state.omnibusErrors;